var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25006 26.0762C2.80505 26.0762 0 29.0035 0 32.5987V53.4709C0 57.0661 2.80505 59.9934 6.25006 59.9934H13.7502C15.1577 59.9934 16.4527 59.4978 17.5002 58.6732V26.0762H6.25006Z",
    fill: "#2B4E7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0006 35.874C60.0006 34.3061 59.4056 32.845 58.3731 31.7674C59.5406 30.4342 60.1356 28.647 59.9731 26.7868C59.6806 23.4707 56.818 20.8721 53.453 20.8721H38.0102C38.7753 18.4483 40.0002 14.0052 40.0002 10.4361C40.0002 4.77708 35.3927 0 32.5001 0C29.9026 0 28.0475 1.52628 27.9676 1.5889C27.6726 1.83679 27.5001 2.21249 27.5001 2.60898V11.4561L20.3 27.7339L20 27.893V55.8565C22.035 56.8584 24.61 57.3985 26.2501 57.3985H49.198C51.9205 57.3985 54.3031 55.4834 54.863 52.8406C55.1505 51.4812 54.983 50.1115 54.4106 48.9218C56.258 47.9512 57.5006 45.9657 57.5006 43.7011C57.5006 42.7775 57.2981 41.8931 56.9131 41.0921C58.7606 40.1216 60.0006 38.1361 60.0006 35.874Z",
    fill: "#2B4E7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFeedbackIcon);
export default __webpack_public_path__ + "static/media/blueFeedbackIcon.96b7b719a0fb9c89be8dee6111846835.svg";
export { ForwardRef as ReactComponent };